"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedTeamScoreServiceServer = exports.ProtectedTeamScoreServiceDispatcher = exports.ProtectedTeamScoreServiceClient = void 0;
var UpdateTeamScoreRequest_1 = require("./UpdateTeamScoreRequest");
var RankWithOthers_1 = require("./RankWithOthers");
var services_shared_1 = require("@playq/services-shared");
var DefaultScore_1 = require("./DefaultScore");
var TeamRankWithTop_1 = require("./TeamRankWithTop");
var TeamLadderInstanceSelection_1 = require("./TeamLadderInstanceSelection");
var UpdateMetaResponse_1 = require("./UpdateMetaResponse");
var UpdateScoreResponse_1 = require("./UpdateScoreResponse");
var TeamRank_1 = require("./TeamRank");
var TeamRankWithOthers_1 = require("./TeamRankWithOthers");
var irt_1 = require("@playq/irt");
var InUpdateScore = (function () {
    function InUpdateScore(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.payload = new UpdateTeamScoreRequest_1.UpdateTeamScoreRequest(data.payload);
    }
    Object.defineProperty(InUpdateScore.prototype, "payload", {
        get: function () {
            return this._payload;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field payload is not optional');
            }
            this._payload = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateScore.prototype.serialize = function () {
        return {
            payload: this.payload.serialize()
        };
    };
    return InUpdateScore;
}());
var OutUpdateScoreHelpers = (function () {
    function OutUpdateScoreHelpers() {
    }
    OutUpdateScoreHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateScoreHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UpdateScoreResponse_1.UpdateScoreResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateScoreHelpers;
}());
var InRemoveScore = (function () {
    function InRemoveScore(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
    }
    Object.defineProperty(InRemoveScore.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    InRemoveScore.prototype.serialize = function () {
        return {
            instance: this.instance.serialize()
        };
    };
    return InRemoveScore;
}());
var OutRemoveScoreHelpers = (function () {
    function OutRemoveScoreHelpers() {
    }
    OutRemoveScoreHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRemoveScoreHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRemoveScoreHelpers;
}());
var InRemoveHistoryScores = (function () {
    function InRemoveHistoryScores(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
    }
    Object.defineProperty(InRemoveHistoryScores.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    InRemoveHistoryScores.prototype.serialize = function () {
        return {
            instance: this.instance.serialize()
        };
    };
    return InRemoveHistoryScores;
}());
var OutRemoveHistoryScoresHelpers = (function () {
    function OutRemoveHistoryScoresHelpers() {
    }
    OutRemoveHistoryScoresHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRemoveHistoryScoresHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRemoveHistoryScoresHelpers;
}());
var InUpdateMeta = (function () {
    function InUpdateMeta(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.meta = Object.keys(data.meta).reduce(function (previous, current) { previous[current] = data.meta[current]; return previous; }, {});
    }
    Object.defineProperty(InUpdateMeta.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateMeta.prototype, "meta", {
        get: function () {
            return this._meta;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field meta is not optional');
            }
            this._meta = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateMeta.prototype.serialize = function () {
        var _this = this;
        return {
            instance: this.instance.serialize(),
            meta: Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {})
        };
    };
    return InUpdateMeta;
}());
var OutUpdateMetaHelpers = (function () {
    function OutUpdateMetaHelpers() {
    }
    OutUpdateMetaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateMetaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UpdateMetaResponse_1.UpdateMetaResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateMetaHelpers;
}());
var InFetchTeamBucket = (function () {
    function InFetchTeamBucket(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.defaultScore = typeof data.defaultScore !== 'undefined' ? new DefaultScore_1.DefaultScore(data.defaultScore) : undefined;
    }
    Object.defineProperty(InFetchTeamBucket.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchTeamBucket.prototype, "defaultScore", {
        get: function () {
            return this._defaultScore;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._defaultScore = undefined;
                return;
            }
            this._defaultScore = value;
        },
        enumerable: false,
        configurable: true
    });
    InFetchTeamBucket.prototype.serialize = function () {
        return {
            instance: this.instance.serialize(),
            defaultScore: typeof this.defaultScore !== 'undefined' ? this.defaultScore.serialize() : undefined
        };
    };
    return InFetchTeamBucket;
}());
var OutFetchTeamBucketHelpers = (function () {
    function OutFetchTeamBucketHelpers() {
    }
    OutFetchTeamBucketHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFetchTeamBucketHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new RankWithOthers_1.RankWithOthers(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFetchTeamBucketHelpers;
}());
var InFetchTeamRank = (function () {
    function InFetchTeamRank(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.defaultScore = typeof data.defaultScore !== 'undefined' ? new DefaultScore_1.DefaultScore(data.defaultScore) : undefined;
    }
    Object.defineProperty(InFetchTeamRank.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchTeamRank.prototype, "defaultScore", {
        get: function () {
            return this._defaultScore;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._defaultScore = undefined;
                return;
            }
            this._defaultScore = value;
        },
        enumerable: false,
        configurable: true
    });
    InFetchTeamRank.prototype.serialize = function () {
        return {
            instance: this.instance.serialize(),
            defaultScore: typeof this.defaultScore !== 'undefined' ? this.defaultScore.serialize() : undefined
        };
    };
    return InFetchTeamRank;
}());
var OutFetchTeamRankHelpers = (function () {
    function OutFetchTeamRankHelpers() {
    }
    OutFetchTeamRankHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFetchTeamRankHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new TeamRank_1.TeamRank(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFetchTeamRankHelpers;
}());
var InFetchNearbyTeams = (function () {
    function InFetchNearbyTeams(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.count = data.count;
        this.defaultScore = typeof data.defaultScore !== 'undefined' ? new DefaultScore_1.DefaultScore(data.defaultScore) : undefined;
    }
    Object.defineProperty(InFetchNearbyTeams.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchNearbyTeams.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field count is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field count expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field count is expected to be an integer, got ' + value);
            }
            this._count = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchNearbyTeams.prototype, "defaultScore", {
        get: function () {
            return this._defaultScore;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._defaultScore = undefined;
                return;
            }
            this._defaultScore = value;
        },
        enumerable: false,
        configurable: true
    });
    InFetchNearbyTeams.prototype.serialize = function () {
        return {
            instance: this.instance.serialize(),
            count: this.count,
            defaultScore: typeof this.defaultScore !== 'undefined' ? this.defaultScore.serialize() : undefined
        };
    };
    return InFetchNearbyTeams;
}());
var OutFetchNearbyTeamsHelpers = (function () {
    function OutFetchNearbyTeamsHelpers() {
    }
    OutFetchNearbyTeamsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFetchNearbyTeamsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new TeamRankWithOthers_1.TeamRankWithOthers(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFetchNearbyTeamsHelpers;
}());
var InFetchAboveRankTeams = (function () {
    function InFetchAboveRankTeams(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.rank = new TeamRank_1.TeamRank(data.rank);
        this.count = data.count;
        this.defaultScore = typeof data.defaultScore !== 'undefined' ? new DefaultScore_1.DefaultScore(data.defaultScore) : undefined;
    }
    Object.defineProperty(InFetchAboveRankTeams.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchAboveRankTeams.prototype, "rank", {
        get: function () {
            return this._rank;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field rank is not optional');
            }
            this._rank = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchAboveRankTeams.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field count is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field count expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field count is expected to be an integer, got ' + value);
            }
            this._count = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchAboveRankTeams.prototype, "defaultScore", {
        get: function () {
            return this._defaultScore;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._defaultScore = undefined;
                return;
            }
            this._defaultScore = value;
        },
        enumerable: false,
        configurable: true
    });
    InFetchAboveRankTeams.prototype.serialize = function () {
        return {
            instance: this.instance.serialize(),
            rank: this.rank.serialize(),
            count: this.count,
            defaultScore: typeof this.defaultScore !== 'undefined' ? this.defaultScore.serialize() : undefined
        };
    };
    return InFetchAboveRankTeams;
}());
var OutFetchAboveRankTeamsHelpers = (function () {
    function OutFetchAboveRankTeamsHelpers() {
    }
    OutFetchAboveRankTeamsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFetchAboveRankTeamsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new TeamRankWithOthers_1.TeamRankWithOthers(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFetchAboveRankTeamsHelpers;
}());
var InFetchBelowRankTeams = (function () {
    function InFetchBelowRankTeams(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.rank = new TeamRank_1.TeamRank(data.rank);
        this.count = data.count;
        this.defaultScore = typeof data.defaultScore !== 'undefined' ? new DefaultScore_1.DefaultScore(data.defaultScore) : undefined;
    }
    Object.defineProperty(InFetchBelowRankTeams.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchBelowRankTeams.prototype, "rank", {
        get: function () {
            return this._rank;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field rank is not optional');
            }
            this._rank = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchBelowRankTeams.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field count is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field count expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field count is expected to be an integer, got ' + value);
            }
            this._count = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchBelowRankTeams.prototype, "defaultScore", {
        get: function () {
            return this._defaultScore;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._defaultScore = undefined;
                return;
            }
            this._defaultScore = value;
        },
        enumerable: false,
        configurable: true
    });
    InFetchBelowRankTeams.prototype.serialize = function () {
        return {
            instance: this.instance.serialize(),
            rank: this.rank.serialize(),
            count: this.count,
            defaultScore: typeof this.defaultScore !== 'undefined' ? this.defaultScore.serialize() : undefined
        };
    };
    return InFetchBelowRankTeams;
}());
var OutFetchBelowRankTeamsHelpers = (function () {
    function OutFetchBelowRankTeamsHelpers() {
    }
    OutFetchBelowRankTeamsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFetchBelowRankTeamsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new TeamRankWithOthers_1.TeamRankWithOthers(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFetchBelowRankTeamsHelpers;
}());
var InFetchTopTeams = (function () {
    function InFetchTopTeams(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.instance = new TeamLadderInstanceSelection_1.TeamLadderInstanceSelection(data.instance);
        this.count = data.count;
        this.defaultScore = typeof data.defaultScore !== 'undefined' ? new DefaultScore_1.DefaultScore(data.defaultScore) : undefined;
    }
    Object.defineProperty(InFetchTopTeams.prototype, "instance", {
        get: function () {
            return this._instance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field instance is not optional');
            }
            this._instance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchTopTeams.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field count is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field count expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field count is expected to be an integer, got ' + value);
            }
            this._count = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFetchTopTeams.prototype, "defaultScore", {
        get: function () {
            return this._defaultScore;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._defaultScore = undefined;
                return;
            }
            this._defaultScore = value;
        },
        enumerable: false,
        configurable: true
    });
    InFetchTopTeams.prototype.serialize = function () {
        return {
            instance: this.instance.serialize(),
            count: this.count,
            defaultScore: typeof this.defaultScore !== 'undefined' ? this.defaultScore.serialize() : undefined
        };
    };
    return InFetchTopTeams;
}());
var OutFetchTopTeamsHelpers = (function () {
    function OutFetchTopTeamsHelpers() {
    }
    OutFetchTopTeamsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFetchTopTeamsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new TeamRankWithTop_1.TeamRankWithTop(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFetchTopTeamsHelpers;
}());
var ProtectedTeamScoreServiceClient = (function () {
    function ProtectedTeamScoreServiceClient(transport) {
        this._transport = transport;
    }
    ProtectedTeamScoreServiceClient.prototype.getPackageName = function () { return ProtectedTeamScoreServiceClient.PackageName; };
    ProtectedTeamScoreServiceClient.prototype.getClassName = function () { return ProtectedTeamScoreServiceClient.ClassName; };
    ProtectedTeamScoreServiceClient.prototype.getFullClassName = function () { return ProtectedTeamScoreServiceClient.FullClassName; };
    ProtectedTeamScoreServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.updateScore = function (payload) {
        var _this = this;
        var __data = new InUpdateScore();
        __data.payload = payload;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'updateScore', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateScoreHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.removeScore = function (instance) {
        var _this = this;
        var __data = new InRemoveScore();
        __data.instance = instance;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'removeScore', __data)
                .then(function (data) {
                try {
                    resolve(OutRemoveScoreHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.removeHistoryScores = function (instance) {
        var _this = this;
        var __data = new InRemoveHistoryScores();
        __data.instance = instance;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'removeHistoryScores', __data)
                .then(function (data) {
                try {
                    resolve(OutRemoveHistoryScoresHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.updateMeta = function (instance, meta) {
        var _this = this;
        var __data = new InUpdateMeta();
        __data.instance = instance;
        __data.meta = meta;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'updateMeta', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateMetaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.fetchTeamBucket = function (instance, defaultScore) {
        var _this = this;
        var __data = new InFetchTeamBucket();
        __data.instance = instance;
        __data.defaultScore = defaultScore;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'fetchTeamBucket', __data)
                .then(function (data) {
                try {
                    resolve(OutFetchTeamBucketHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.fetchTeamRank = function (instance, defaultScore) {
        var _this = this;
        var __data = new InFetchTeamRank();
        __data.instance = instance;
        __data.defaultScore = defaultScore;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'fetchTeamRank', __data)
                .then(function (data) {
                try {
                    resolve(OutFetchTeamRankHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.fetchNearbyTeams = function (instance, count, defaultScore) {
        var _this = this;
        var __data = new InFetchNearbyTeams();
        __data.instance = instance;
        __data.count = count;
        __data.defaultScore = defaultScore;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'fetchNearbyTeams', __data)
                .then(function (data) {
                try {
                    resolve(OutFetchNearbyTeamsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.fetchAboveRankTeams = function (instance, rank, count, defaultScore) {
        var _this = this;
        var __data = new InFetchAboveRankTeams();
        __data.instance = instance;
        __data.rank = rank;
        __data.count = count;
        __data.defaultScore = defaultScore;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'fetchAboveRankTeams', __data)
                .then(function (data) {
                try {
                    resolve(OutFetchAboveRankTeamsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.fetchBelowRankTeams = function (instance, rank, count, defaultScore) {
        var _this = this;
        var __data = new InFetchBelowRankTeams();
        __data.instance = instance;
        __data.rank = rank;
        __data.count = count;
        __data.defaultScore = defaultScore;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'fetchBelowRankTeams', __data)
                .then(function (data) {
                try {
                    resolve(OutFetchBelowRankTeamsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.prototype.fetchTopTeams = function (instance, count, defaultScore) {
        var _this = this;
        var __data = new InFetchTopTeams();
        __data.instance = instance;
        __data.count = count;
        __data.defaultScore = defaultScore;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamScoreServiceClient.ClassName, 'fetchTopTeams', __data)
                .then(function (data) {
                try {
                    resolve(OutFetchTopTeamsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamScoreServiceClient.PackageName = 'net.playq.services.clerk';
    ProtectedTeamScoreServiceClient.ClassName = 'ProtectedTeamScoreService';
    ProtectedTeamScoreServiceClient.FullClassName = 'net.playq.services.clerk.ProtectedTeamScoreService';
    return ProtectedTeamScoreServiceClient;
}());
exports.ProtectedTeamScoreServiceClient = ProtectedTeamScoreServiceClient;
var ProtectedTeamScoreServiceDispatcher = (function () {
    function ProtectedTeamScoreServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    ProtectedTeamScoreServiceDispatcher.prototype.getSupportedService = function () {
        return 'ProtectedTeamScoreService';
    };
    ProtectedTeamScoreServiceDispatcher.prototype.getSupportedMethods = function () {
        return ProtectedTeamScoreServiceDispatcher.methods;
    };
    ProtectedTeamScoreServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "updateScore": {
                var obj_1 = new InUpdateScore(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateScore(context, obj_1.payload)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateScoreHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "removeScore": {
                var obj_2 = new InRemoveScore(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.removeScore(context, obj_2.instance)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRemoveScoreHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "removeHistoryScores": {
                var obj_3 = new InRemoveHistoryScores(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.removeHistoryScores(context, obj_3.instance)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRemoveHistoryScoresHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateMeta": {
                var obj_4 = new InUpdateMeta(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateMeta(context, obj_4.instance, obj_4.meta)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateMetaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "fetchTeamBucket": {
                var obj_5 = new InFetchTeamBucket(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.fetchTeamBucket(context, obj_5.instance, obj_5.defaultScore)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFetchTeamBucketHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "fetchTeamRank": {
                var obj_6 = new InFetchTeamRank(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.fetchTeamRank(context, obj_6.instance, obj_6.defaultScore)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFetchTeamRankHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "fetchNearbyTeams": {
                var obj_7 = new InFetchNearbyTeams(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.fetchNearbyTeams(context, obj_7.instance, obj_7.count, obj_7.defaultScore)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFetchNearbyTeamsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "fetchAboveRankTeams": {
                var obj_8 = new InFetchAboveRankTeams(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.fetchAboveRankTeams(context, obj_8.instance, obj_8.rank, obj_8.count, obj_8.defaultScore)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFetchAboveRankTeamsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "fetchBelowRankTeams": {
                var obj_9 = new InFetchBelowRankTeams(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.fetchBelowRankTeams(context, obj_9.instance, obj_9.rank, obj_9.count, obj_9.defaultScore)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFetchBelowRankTeamsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "fetchTopTeams": {
                var obj_10 = new InFetchTopTeams(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.fetchTopTeams(context, obj_10.instance, obj_10.count, obj_10.defaultScore)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFetchTopTeamsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by ProtectedTeamScoreServiceDispatcher."));
        }
    };
    ProtectedTeamScoreServiceDispatcher.methods = [
        "updateScore",
        "removeScore",
        "removeHistoryScores",
        "updateMeta",
        "fetchTeamBucket",
        "fetchTeamRank",
        "fetchNearbyTeams",
        "fetchAboveRankTeams",
        "fetchBelowRankTeams",
        "fetchTopTeams"
    ];
    return ProtectedTeamScoreServiceDispatcher;
}());
exports.ProtectedTeamScoreServiceDispatcher = ProtectedTeamScoreServiceDispatcher;
var ProtectedTeamScoreServiceServer = (function (_super) {
    __extends(ProtectedTeamScoreServiceServer, _super);
    function ProtectedTeamScoreServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    ProtectedTeamScoreServiceServer.prototype.updateScore = function (context, payload) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.removeScore = function (context, instance) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.removeHistoryScores = function (context, instance) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.updateMeta = function (context, instance, meta) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.fetchTeamBucket = function (context, instance, defaultScore) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.fetchTeamRank = function (context, instance, defaultScore) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.fetchNearbyTeams = function (context, instance, count, defaultScore) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.fetchAboveRankTeams = function (context, instance, rank, count, defaultScore) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.fetchBelowRankTeams = function (context, instance, rank, count, defaultScore) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamScoreServiceServer.prototype.fetchTopTeams = function (context, instance, count, defaultScore) {
        throw new Error('Not implemented.');
    };
    return ProtectedTeamScoreServiceServer;
}(ProtectedTeamScoreServiceDispatcher));
exports.ProtectedTeamScoreServiceServer = ProtectedTeamScoreServiceServer;
//# sourceMappingURL=ProtectedTeamScoreService.js.map